import { render } from "./AmericanExpress.vue?vue&type=template&id=5e4df044"
import script from "./AmericanExpress.vue?vue&type=script&lang=js"
export * from "./AmericanExpress.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5e4df044"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e4df044', script)) {
    api.reload('5e4df044', script)
  }
  
  module.hot.accept("./AmericanExpress.vue?vue&type=template&id=5e4df044", () => {
    api.rerender('5e4df044', render)
  })

}

script.__file = "src/icons/components/logos/AmericanExpress.vue"

export default script